/**
 * Final shape returned by `userAPIClient.getCookieUser()`.
 * - Logged‑in → `CookieUser`
 * - Not logged‑in (401) → `null`
 */
export type GetCookieUserResponse = {
  id: number;
  username: string;
  email: string;
  display_name: string;
  roles: string[];
  cookie_source: string;
} | null;

// Update user address
export type UserAddress = {
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string;
  city: string;
  postcode: string;
  country: string;
  state?: string;
  phone?: string;
};

export type UpdateUserRequest = {
  userId: number;
  email?: {
    emailAddress: string;
    subscribed: boolean;
  };
  address?: {
    shipping: UserAddress;
    billing: UserAddress;
  };
};

export type UpdateUserResponse = unknown;

// GET /wp-json/skinseoul/v1/user
export type GetUserResponse = {
  userId: number;
  address: {
    shipping: UserAddress;
    billing: UserAddress;
  };
  email: {
    emailAddress: string;
    subscribed: boolean;
  };
} | null;
